import { Component, OnInit, Renderer2, ChangeDetectionStrategy, OnDestroy, AfterViewInit } from '@angular/core';
import { Select } from '@ngxs/store';
import { LayoutState } from '../../state/layout.state';
import { LayoutThemeEnum } from '../../models/layout-theme.enum';
import { Observable, Subject } from 'rxjs';
import { takeUntil, filter, take } from 'rxjs/operators';
import { AuthState } from 'src/app/auth/state/auth/auth.state';
import { UserProfileModel } from 'src/app/auth/models/user-profile.model';
import { AuthService } from 'src/app/auth/auth.service';
import { MatDialog } from '@angular/material';
import { StorageService, StorageItemEnum } from 'src/app/shared/storage.service';
import { ActivatedRoute } from '@angular/router';

import * as _ from 'lodash';
import { DialogService } from 'src/app/dialogs/dialog.service';

@Component({
  selector: 'app-master',
  templateUrl: './master.component.html',
  styleUrls: ['./master.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MasterComponent implements OnInit, OnDestroy {
  @Select(LayoutState.getTheme)
  theme$: Observable<LayoutThemeEnum>;

  @Select(AuthState.getUserProfile)
  profile$: Observable<UserProfileModel>;

  showHeader = false;

  private ngUnsubscribe = new Subject();

  constructor(
    private renderer: Renderer2,
    private authService: AuthService,
    private storageService: StorageService,
    private route: ActivatedRoute,
    private dialogService: DialogService
  ) {
    this.showHeader = this.route.snapshot.data.showHeader;
  }

  ngOnInit() {
    this.theme$
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((theme: LayoutThemeEnum) => {
        this.renderer.removeClass(document.body, LayoutThemeEnum.Dark);
        this.renderer.removeClass(document.body, LayoutThemeEnum.Light);
        
        this.renderer.addClass(document.body, theme);
      });

    this.profile$
      .pipe(
        filter(profile => profile != null),
        take(1),
        takeUntil(this.ngUnsubscribe)
      )
      .subscribe(profile => {
        this.checkProfileAccess(profile);
      });
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  checkProfileAccess(profile: UserProfileModel) {
    const profileRestrictions = this.authService.getProfileRestrictions(profile);
    const restrictionSettings = this.storageService.getLocalJSON(StorageItemEnum.GroupRestriction);
    const showDialog = _.get(restrictionSettings, 'dontShowDialog') !== true;
    
    if (showDialog && (profileRestrictions.email || profileRestrictions.ip)) {
      setTimeout(() => {
        this.dialogService.openGroupRestrictionDialog({
          data: {
            ...profileRestrictions
          }
        });
      });
    }
  }


}
